export function sortObjectByKeys(o) {
  return Object.keys(o)
    .sort()
    .reduce((r, k) => ((r[k] = o[k]), r), {})
}

export function getSortKeys(list, key, label = null) {
  let arr = []
  if (!Array.isArray(list)) return arr

  list.map((i) => {
    const objToSort = i[key]
    if (objToSort) {
      const objSort = sortObjectByKeys(objToSort)
      for (const [index, other] of Object.entries(objSort)) {
        if (other.type != 'json') {
          if (label) {
            arr.push(other.label)
          } else {
            arr.push(index)
          }
        }
      }
    }
  })

  return [...new Set(arr)]
}
